import { gql } from "@apollo/client";

export const GET_USER_DETAILS = gql`
  query getAccountDetails {
    getAccountDetails {
      userCompanyDetails {
        customer_company_name
        company_website
        company_description
        isActive
        plan
      }
      userIntegrationsDetails {
        list {
          id
          account_label
          account_email
          is_active
          integration_label
          integration_key
          integration_id
          use_as_idp
          idp_priority
        }
        hasHrmsIntegration
      }
      userDetails {
        name
        employee_data_id
        user_id
        user_type
        entitlements
        roles {
          role_id
          role_name
          role_description
          is_active
        }
        permissions
      }
    }
  }
`;

export const GET_MODULE_LIST = gql`
  query getModuleList {
    getModuleList {
      moduleId
      moduleName
      moduleDescription
      controls {
        controlsId
        controlsName
        controlsDescription
        controlsTitle
        controlsDomain
        checks {
          activeCheckId
          activeCheckName
          activeCheckDescription
          activeCheckCategory
          checkType
          checkStatus
          monitorType
          checkStatusReason
        }
      }
    }
  }
`;

export const GET_FRAMEWORK_DETAIL_BY_ID = gql`
  query getFrameworkDetailByFrameworkId($framework_id: Int!) {
    getFrameworkDetailByFrameworkId(framework_id: $framework_id) {
      areaDetails {
        area_id
        area_name
        criterias {
          criteria_id
          controls {
            controlsId
            controlsName
            controlsDescription
            controlsTitle
            controlsDomain
            controlOwnerData {
              name
              email
            }
            checks {
              checkType
              monitorType
              checkStatus
              activeCheckId
              activeCheckName
              activeCheckDescription
              activeCheckCategory
              checkStatusReason
            }
          }
        }
      }
    }
  }
`;

export const GET_ROLES = gql`
  query getRoles {
    getRoles {
      role_id
      role_name
      role_description
      is_active
    }
  }
`;

export const GET_ALL_ROLES = gql`
  query getAllRoles {
    getAllRoles {
      role_id
      role_name
      role_description
      is_active
    }
  }
`;
